import { csx } from '@vtex/admin-ui'

const baseStyle = csx({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'transparent',
  '*': { color: '$secondary' },
  ':first-child': {
    borderTopLeftRadius: 4,
    borderBottomLeftRadius: 4,
  },
  ':last-child': {
    borderTopRightRadius: 4,
    borderBottomRightRadius: 4,
  },
  'input[type=radio]': { display: 'none' },
  height: '3rem',
  width: '9rem',
  cursor: 'pointer',
})

export interface SelectButtonProps {
  name: string
  options: Array<{ label: React.ReactNode; value: string }>
  value: string
  onChange: (value: string) => void
  disabled?: boolean
}

export function SelectButton(props: SelectButtonProps) {
  const { name, options, value, onChange, disabled } = props

  return (
    <fieldset className={csx({ display: 'flex' })} name={name}>
      {options.map((option) => {
        const selected = option.value === value

        const stateStyle = csx(
          selected
            ? {
                border: '$mainSelected',
                '*': { color: '$action.main.secondary' },
              }
            : {
                border: '$form.neutral',
                ':hover': { border: '$form.neutralHover' },
              }
        )

        return (
          <label key={option.value} className={`${baseStyle} ${stateStyle}`}>
            <input
              name={name}
              type="radio"
              disabled={disabled}
              value={option.value}
              checked={option.value === value}
              onChange={(e) => onChange(e.target.value)}
            />
            {option.label}
          </label>
        )
      })}
    </fieldset>
  )
}
